<template>
    <div v-if="!editMode" class="innerPadding30 margin30Top description" style="padding-bottom:20px; border: 1px solid #000;">
        <div class="oldTableContainer width100 fontRoboto">
            User Content Administration...
            <hr/>
            <div class="textAlignRight buttonBlockContainerRight">
                <button v-on:click="enterEditMode" class="btn btn-white teaserButton">Weiter</button>
            </div>
        </div>
    </div>
	<div v-else class="border-color-editor" style="margin-top:30px;padding-bottom:20px">
        <div class="oldInnerWrapper tabContent" id="berichte1">
            <form>
                User Content Administration...
                <hr/>
                <div style="margin-top:5px">
                    <div class="radioCheckContainer">
                        <input type="checkbox" id="enable_reports" name="enable_reports" v-model="model.report.enabled"/>
                        <label class="clearfix" for="enable_reports">Berichte unterstützen</label>
                    </div>
                </div>
                <div v-if="model.report.enabled">
                    <select name="report_visibility" style="margin-top:20px" v-model="model.report.visibility" v-validate="'required'" :class="{'error': errors.has('report_visibility')}">
                        <option value="">Sichtbarkeit auswählen</option>
                        <option value="PROJECT">Für Projektteilnehmer einsehbar</option>
                        <option value="HIDDEN">Nur von der Redaktion einsehbar</option>
                    </select>				
                    <select name="report_privilege" style="margin-top:20px" v-model="model.report.privilege" v-validate="'required'" :class="{'error': errors.has('report_privilege')}">
                        <option value="">Editierbarkeit auswählen</option>
                        <option value="PROJECT_PARTICIPANT">Nur Projektteilnehmer können Inhalte einstellen</option>
                        <option value="EDITOR">Nur die Redaktion kann Inhalte einstellen</option>
                    </select>				
                </div>

                <hr/>
                <div style="margin-top:5px">
                    <div class="radioCheckContainer">
                        <input type="checkbox" id="enable_links" name="enable_links" v-model="model.links.enabled"/>
                        <label class="clearfix" for="enable_links">Links/Videos unterstützen</label>
                    </div>
                </div>
                <div v-if="model.links.enabled">
                    <select name="links_visibility" style="margin-top:20px" v-model="model.links.visibility" v-validate="'required'" :class="{'error': errors.has('links_visibility')}">
                        <option value="">Sichtbarkeit auswählen</option>
                        <option value="PUBLIC">Öffentlich einsehbar</option>
                        <option value="PROJECT">Für Projektteilnehmer einsehbar</option>
                        <option value="HIDDEN">Nur von der Redaktion einsehbar</option>
                    </select>				
                    <select name="links_privilege" style="margin-top:20px" v-model="model.links.privilege" v-validate="'required'" :class="{'error': errors.has('links_privilege')}">
                        <option value="">Editierbarkeit auswählen</option>
                        <option value="EVERYONE">Jeder kann Inhalte einstellen</option>
                        <option value="PROJECT_PARTICIPANT">Nur Projektteilnehmer können Inhalte einstellen</option>
                        <option value="EDITOR">Nur die Redaktion kann Inhalte einstellen</option>
                    </select>				
                </div>

                <hr/>
                <div style="margin-top:5px">
                    <div class="radioCheckContainer">
                        <input type="checkbox" id="enable_images" name="enable_images" v-model="model.images.enabled"/>
                        <label class="clearfix" for="enable_images">Bilder unterstützen</label>
                    </div>
                </div>
                <div v-if="model.images.enabled">
                    <select name="images_visibility" style="margin-top:20px" v-model="model.images.visibility" v-validate="'required'" :class="{'error': errors.has('images_visibility')}">
                        <option value="">Sichtbarkeit auswählen</option>
                        <option value="PUBLIC">Öffentlich einsehbar</option>
                        <option value="PROJECT">Für Projektteilnehmer einsehbar</option>
                        <option value="HIDDEN">Nur von der Redaktion einsehbar</option>
                    </select>				
                    <select name="images_privilege" style="margin-top:20px" v-model="model.images.privilege" v-validate="'required'" :class="{'error': errors.has('images_privilege')}">
                        <option value="">Editierbarkeit auswählen</option>
                        <option value="EVERYONE">Jeder kann Inhalte einstellen</option>
                        <option value="PROJECT_PARTICIPANT">Nur Projektteilnehmer können Inhalte einstellen</option>
                        <option value="EDITOR">Nur die Redaktion kann Inhalte einstellen</option>
                    </select>				
                </div>

                <hr/>
                <div style="margin-top:5px">
                    <div class="radioCheckContainer">
                        <input type="checkbox" id="enable_receipe" name="enable_receipe" v-model="model.receipe.enabled"/>
                        <label class="clearfix" for="enable_receipe">Rezepte unterstützen</label>
                    </div>
                </div>
                <div v-if="model.receipe.enabled">
                    <select name="receipe_visibility" style="margin-top:20px" v-model="model.receipe.visibility" v-validate="'required'" :class="{'error': errors.has('receipe_visibility')}">
                        <option value="">Sichtbarkeit auswählen</option>
                        <option value="PUBLIC">Öffentlich einsehbar</option>
                        <option value="PROJECT">Für Projektteilnehmer einsehbar</option>
                        <option value="HIDDEN">Nur von der Redaktion einsehbar</option>
                    </select>				
                    <select name="receipe_privilege" style="margin-top:20px" v-model="model.receipe.privilege" v-validate="'required'" :class="{'error': errors.has('receipe_privilege')}">
                        <option value="">Editierbarkeit auswählen</option>
                        <option value="EVERYONE">Jeder kann Inhalte einstellen</option>
                        <option value="PROJECT_PARTICIPANT">Nur Projektteilnehmer können Inhalte einstellen</option>
                        <option value="EDITOR">Nur die Redaktion kann Inhalte einstellen</option>
                    </select>				
                </div>

                <hr/>
                <div style="margin-top:5px">
                    <div class="radioCheckContainer">
                        <input type="checkbox" id="enable_replies" name="enable_replies" v-model="model.reply.enabled"/>
                        <label class="clearfix" for="enable_replies">Antworten unterstützen</label>
                    </div>
                </div>
                <div v-if="model.reply.enabled">
                    <select name="reply_visibility" style="margin-top:20px" v-model="model.reply.visibility" v-validate="'required'" :class="{'error': errors.has('reply_visibility')}">
                        <option value="">Sichtbarkeit auswählen</option>
                        <option value="PUBLIC">Öffentlich einsehbar</option>
                        <option value="PROJECT">Für Projektteilnehmer einsehbar</option>
                        <option value="HIDDEN">Nur von der Redaktion einsehbar</option>
                    </select>				
                    <select name="reply_privilege" style="margin-top:20px" v-model="model.reply.privilege" v-validate="'required'" :class="{'error': errors.has('reply_privilege')}">
                        <option value="">Editierbarkeit auswählen</option>
                        <option value="EVERYONE">Jeder kann Inhalte einstellen</option>
                        <option value="PROJECT_PARTICIPANT">Nur Projektteilnehmer können Inhalte einstellen</option>
                        <option value="EDITOR">Nur die Redaktion kann Inhalte einstellen</option>
                    </select>				
                </div>
                <hr/>
				<div>
					<div>
						<label>SEO Title</label> <input type="text"
							v-model="model.seoTitle">
					</div>
					<div>
						<label>SEO Description</label> <input type="text"
							v-model="model.seoDescription">
					</div>
					<div>
						<label>SEO Keywords</label> <input type="text"
							v-model="model.seoKeywords">
					</div>
				</div>
                <hr/>
				<div class="textAlignRight buttonBlockContainerRight">
                    <button type="button" v-on:click="leaveEditMode" class="btn btn-white teaserButton width50">Abbrechen</button>
                    <button type="button" v-on:click="save" class="btn btn-white teaserButton width50">Absenden</button>
                </div>
            </form>
        </div><!-- end berichte1 -->
	</div><!-- border-color1 -->
</template>

<script>
	export default {
		name: 'userContentAdministration',
		props: {
            project: String
        },
        data: function() {
        	return {
                editMode : false,
                model: {
                    report: {
                        enabled: false,
                        visibility: '',
                        privilege: ''
                    },
                    links: {
                        enabled: false,
                        visibility: '',
                        privilege: ''
                    },
                    images: {
                        enabled: false,
                        visibility: '',
                        privilege: ''
                    },
                    receipe: {
                        enabled: false,
                        visibility: '',
                        privilege: ''
                    },
                    reply: {
                        enabled: false,
                        visibility: '',
                        privilege: ''
                    },
                    seoTitle: '',
                    seoDescription: '',
                    seoKeywords: ''
                }
        	}
        },
        created: function() {
            console.log('creating user content administration for project ' + this.project);
            this.load(this);
        },
        methods: {
        	enterEditMode: function() {
        		this.editMode = true;
            },
            leaveEditMode: function() {
                this.editMode = false;
            },
            load: function() {
                var self = this;
                jQuery.ajax ({
                    url: '/project/' + self.project + '/content/definition',
                    type: 'GET',
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        Object.assign(self.model.report, data.report);
                        Object.assign(self.model.links, data.links);
                        Object.assign(self.model.images, data.images);
                        Object.assign(self.model.receipe, data.receipe);
                        Object.assign(self.model.reply, data.reply);
                        //primitives koennen nicht assigned werden
                        self.model.seoTitle = data.seoTitle;
                        self.model.seoDescription = data.seoDescription;
                        self.model.seoKeywords = data.seoKeywords;
                    },
                    error: function() {alert("error");}
                });
            },
            save: function() {
                this.$validator.validateAll();
                if (this.errors.any()) {
                    return;
                }
                var self = this;
                var selfModel = {
                    report: {
                        enabled: false
                    },
                    links: {
                        enabled: false
                    },
                    images: {
                        enabled: false
                    },
                    receipe: {
                        enabled: false
                    },
                    reply: {
                        enabled: false
                    },
                    seoTitle: '',
                    seoDescription: '',
                    seoKeywords: ''
                };
                if (self.model.report.enabled) {
                    Object.assign(selfModel.report, self.model.report);
                }
                if (self.model.links.enabled) {
                    Object.assign(selfModel.links, self.model.links);
                }
                if (self.model.images.enabled) {
                    Object.assign(selfModel.images, self.model.images);
                }
                if (self.model.receipe.enabled) {
                    Object.assign(selfModel.receipe, self.model.receipe);
                }
                if (self.model.reply.enabled) {
                    Object.assign(selfModel.reply, self.model.reply);
                }
                selfModel.seoTitle = self.model.seoTitle;
                selfModel.seoDescription = self.model.seoDescription;
                selfModel.seoKeywords = self.model.seoKeywords;
                console.log('sending ' + JSON.stringify(selfModel));
                jQuery.ajax ({
                    url: '/project/' + self.project + '/content/definition',
                    type: 'POST',
                    dataType: 'json',
                    data: JSON.stringify(selfModel),
                    contentType: "application/json; charset=utf-8",
                    success: function(data) {
                        Object.assign(self.model.report, data.report);
                        Object.assign(self.model.links, data.links);
                        Object.assign(self.model.images, data.images);
                        Object.assign(self.model.receipe, data.receipe);
                        Object.assign(self.model.reply, data.reply);
                        //primitives koennen nicht assigned werden
                        self.model.seoTitle = data.seoTitle;
                        self.model.seoDescription = data.seoDescription;
                        self.model.seoKeywords = data.seoKeywords;
                        window.location.href = '/project/' + self.project + '/content.html';
                    },
                    error: function() {alert("error");}
                });
            }
        }
	}
</script>


// WEBPACK FOOTER //
// UserContentAdministration.vue?4f54ed38